import { css } from "../../../../styled-system/css";

const outlinePositions = {
  top: "-4px",
  left: "-4px",
  width: "calc(100% + 8px)",
  height: "calc(100% + 8px)",
};

export const styles = {
  hotSpotWrapper: (showTooltip: boolean) =>
    css({
      display: "flex",
      position: "absolute",
      top: "calc(var(--hotspot-mobile-y) - 12px)",
      left: "calc(var(--hotspot-mobile-x) - 12px)",
      zIndex: showTooltip ? "floating" : undefined,
      tabletLandscape: {
        top: "calc(var(--hotspot-desktop-y) - 12px)",
        left: "calc(var(--hotspot-desktop-x) - 12px)",
      },
    }),
  hotSpot: () =>
    css({
      width: "baseUnit.mobile3",
      height: "baseUnit.mobile3",
      background: "linkBlue",
      borderRadius: "50%",
      outline: "4px solid",
      outlineColor: "linkBlue.transparent",
      transition: "all 0.2s ease",
      position: "relative",
      _before: {
        content: '""',
        position: "absolute",
        borderRadius: "50%",
        border: "4px solid",
        borderColor: "linkBlue",
        opacity: 0,
        pointerEvents: "none",
        animation: "pulseWithScale 1.5s infinite",
        animationDelay: "0.7s",
        ...outlinePositions,
      },
      _after: {
        content: '""',
        position: "absolute",
        borderRadius: "50%",
        border: "2px solid transparent",
        transition: "border-color 0.2s ease",
        ...outlinePositions,
      },
      _hover: {
        background: "darkBlue",
        outlineColor: "darkBlue.transparent",
      },
      _focus: {
        background: "darkBlue",
        outlineColor: "darkBlue.transparent",
        _after: {
          borderColor: "darkBlue",
        },
      },
      _disabled: {
        background: "darkGrey",
        outlineColor: "black.transparent",
        cursor: "default",
        _before: {
          display: "none",
        },
        _hover: {
          background: "darkGrey",
          outlineColor: "black.transparent",
        },
      },
    }),
  tooltip: (tooltipOnTop: boolean, tooltipToLeft: boolean, showTooltip: boolean) =>
    css({
      position: "fixed",
      display: showTooltip ? "block" : "none",
      width: "328px",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      animation: showTooltip ? "visibilityFade 0.2s ease forwards" : "none",
      background: "#171717",
      color: "white",
      padding: "baseUnit.mobile2",
      borderRadius: "baseUnit.mobile2",
      boxShadow: "damageExplainerTooltip",
      opacity: 0,
      tabletLandscape: {
        position: "absolute",
        top: !tooltipOnTop ? "baseUnit.mobile5" : "initial",
        bottom: tooltipOnTop ? "baseUnit.mobile5" : "initial",
        left: !tooltipToLeft ? "-20px" : "initial",
        right: tooltipToLeft ? "-20px" : "initial",
        transform: "none",
        animation: "fadeIn 0.2s ease forwards",
      },
      _after: {
        display: "none",
        content: '""',
        position: "absolute",
        width: "16px",
        height: "16px",
        background: "#171717",
        borderTopLeftRadius: "4px",
        borderBottomRightRadius: "4px",
        transform: "rotate(45deg)",
        top: !tooltipOnTop ? "-baseUnit.mobile1" : undefined,
        bottom: tooltipOnTop ? "-baseUnit.mobile1" : undefined,
        left: !tooltipToLeft ? "baseUnit.mobile3" : undefined,
        right: tooltipToLeft ? "baseUnit.mobile3" : undefined,
        tabletLandscape: {
          display: "block",
        },
      },
    }),
  tooltipTitle: () =>
    css({
      color: "white",
      fontSize: "body.butterfly",
      lineHeight: "16px",
      fontWeight: "700",
      marginBottom: 0,
      paddingRight: "baseUnit.mobile2",
      tabletLandscape: {
        paddingRight: 0,
      },
    }),
  tooltipDescription: () =>
    css({
      "& p": {
        color: "white",
        fontSize: "body.butterfly",
        lineHeight: "16px",
        marginBottom: "baseUnit.mobile1",
        _lastOfType: {
          marginBottom: 0,
        },
      },
    }),
  tooltipCloseButton: () =>
    css({
      position: "absolute",
      width: "baseUnit.mobile3",
      height: "baseUnit.mobile3",
      top: "baseUnit.mobile1",
      right: "baseUnit.mobile1",
      cursor: "pointer",
      "& svg": {
        "& path": {
          fill: "white",
        },
      },
      tabletLandscape: {
        display: "none",
      },
    }),
  tooltipBackdrop: () =>
    css({
      position: "fixed",
      content: '""',
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "black.transparent",
      animation: "visibilityFade 0.2s ease forwards",
      tabletLandscape: {
        display: "none",
      },
    }),
};
